export const providerRoles = [
  {
    id: 5,
    name: 'Physician',
  },
  {
    id: 6,
    name: 'Nurse Practitioner',
  },
  {
    id: 7,
    name: 'Physician Assistant',
  },
  {
    id: 8,
    name: 'Nurse',
  },
  {
    id: 9,
    name: 'Admin Assistant',
  },
  {
    id: 10,
    name: 'Medical Assistant',
  },
  {
    id: 11,
    name: 'Dietitian',
  },
  {
    id: 12,
    name: 'Midwife',
  },
];
